import { render, staticRenderFns } from "./EnvironmentRibbon.vue?vue&type=template&id=7b8de1cd"
import script from "./EnvironmentRibbon.vue?vue&type=script&lang=js"
export * from "./EnvironmentRibbon.vue?vue&type=script&lang=js"
import style0 from "./EnvironmentRibbon.vue?vue&type=style&index=0&id=7b8de1cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports